module.exports = __webpack_public_path__ + "img/fire-flame-02.da2a00dc.png";